<template>
  <animeta-transition
    :to="to"
    :from="from"
    @after-enter="enter"
    @after-leave="leave"
  >
    <slot :visible="reallyVisible" />
  </animeta-transition>
</template>

<script>
import animeta from 'vue-animeta'

export default {
  name: 'PanelTransition',

  components: {
    ...animeta
  },

  props: {
    to: {
      type: Object,
      required: true
    },

    from: {
      type: Object,
      required: true
    },

    visible: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      next: false,
      reallyVisible: this.visible
    }
  },

  methods: {
    enter () {
      if (this.next) {
        this.next()
      }
    },

    leave () {
      if (this.next) {
        this.next()
      }
    },

    hide (next) {
      this.next = next
      this.reallyVisible = false
    },

    show (next) {
      this.next = next
      this.reallyVisible = true
    }
  }
}
</script>
